import React from 'react';

import ContentBuilder from '../../src/containers/ContentBuilder';
import Article from '../../src/containers/Community/Article';
import Community from '../../src/containers/Community';
import ContactUs from '../../src/containers/ContactUs';
import Stock from '../../src/containers/Stock';


import {theme} from '../../src/themes/default-theme';
import styled from '@emotion/styled';
import {get} from 'lodash';
import {gql} from '@apollo/client';

import client from '../../src/graphql/client';
import refactorHb from '../../src/data-restructure/multimedia/hero-banner';
import respImgQuery from '../../src/graphql/queries/resp-img';
import Banner from '../../src/components/multimedia/Banner';
import {Cta} from '../../src/components/ui';
import TradeIn from '../../src/containers/Forms/TradeIn';


const ErrorContainer = styled.div`

`

const TextContainer = styled.div`
  padding: 27px 54px;
  max-width: 780px;
  margin: 100px auto;
  text-align: center;

	& a {
		color: inherit;
	}

	& .MuiButtonBase-root {
    color: white !important;
    ${theme.breakpoints.up('md')} {
      margin: 15px 20px;
    }
    ${theme.breakpoints.down('sm')} {
      width: 100%;
      text-align: center;
      margin-top: 10px;
    }
	}
	& .strong {
		color: ${theme.palette.vividBlue} !important;
	}

	${theme.breakpoints.down('sm')} {
    margin: 40px auto;
    padding-left: 15px;
    padding-right: 15px;
    text-align: left;
	}
` 

const BodyText = styled.div`
	font-size: 14px;
	font-weight: 400;

	${theme.breakpoints.down('sm')} {
		font-size: 14px;

		ul,
		ol {
			font-size: 14px;
		}
	}
` 

const CtaItem = styled.div`
	display: inline-block;
	margin-right: 30px;

	${theme.breakpoints.down('sm')} {
		display: block;
		margin: 0;
		margin-bottom: 10px;
	}
	
	button {
		min-width: 263px;
		${theme.breakpoints.down('sm')} {
			width: 100%;
			min-width: auto;
		}
	}
`

const StaticlyTemplates = (props) => {
  if (props.type === 'basic-page') {
    if (props.router.asPath.indexOf('/stock') !== -1) {
      return <Stock {...props} />
    }

    console.log('StaticlyTemplate', props);
    if (props.router.asPath.indexOf('/trade-in') === 0) {
    // if (props.router.asPath === '/trade-in') {
      return <>
        <ContentBuilder dealerCb={true} topOfDealerPage={true} />
        <TradeIn
          countryProps={props.countryProps}
        />
      </>
    }
    
    return <ContentBuilder dealerCb={true} topOfDealerPage={true} />
  }
  if (props.type === 'article') {
    return <Article negativeMargin={true}/>
  }
  if (props.type === 'article-category') {
    // if (props.router.asPath === '/community') {
      return <>
        {/* <ContentBuilder dealerCb={true} /> */}
        <Community {...props} categoryLocation={props.router.asPath} />
      </>
    // }
    // return <>
    //     {/* <ContentBuilder dealerCb={true} /> */}
    //     <CategoryPage />
    //   </>
  }
  if (props.type === 'contact-page') {
    return <ContactUs />
  }

  return (
  	<ErrorContainer>
      {props.heroBanner &&
        <Banner
          mainHeading="Whoopsies"
          subHeading2="Page cannot be found"
          bgImage={props.heroBanner.bgImage}
          type="mediumBanner"
        />
      }
      <TextContainer>
        <BodyText dangerouslySetInnerHTML={{ __html: 'Sorry, but the page you’re looking for does not exist or has been deleted. Please check the address of the page you were looking for or click below to browse the Jayo range or return to the home page.' }} />
        <CtaItem>
          <Cta
            href={'/range'}
            inline 
            outline={false}
          >
            Browse the range
          </Cta>
          <Cta
            className={'strong'}
            href={'/'} 
            inline 
            outline={true}
          >
            Return to home
          </Cta>
        </CtaItem>
      </TextContainer>
    </ErrorContainer>
  )
}

export async function getStaticPaths() {

  const mainSite = !process.env.DEALER_SITE

  const paths = mainSite ? [{
    params: {
      id: '404' // needs at least one page
    }
  }] : [{ 
    params: { 
      id: 'basic-page' 
    } 
  },{ 
    params: { 
      id: 'article' 
    } 
  },{ 
    params: { 
      id: 'article-category' 
    } 
  },{ 
    params: { 
      id: 'contact-page' 
    } 
  }]

  // if (mainSite) {
  //   return
  // }

  return { paths, fallback: 'blocking' }
}

export async function getStaticProps({ params }) {
  const GET_PAGE_CONTEXT = gql`
    query GET_FAQ_PAGE {
      pageBy(uri: "faqs") {
        acf_content_builder {
          contentBuilder {
            ... on Page_AcfContentBuilder_ContentBuilder_FcSingleHeroBanner {
              fieldGroupName
              shbHeadingText
              shbBannerImage {
                ${respImgQuery}
              }
            }
          }
        }
      }
    }
  `

  const contextProps = await client.query({
    query: GET_PAGE_CONTEXT
  });

  if (contextProps) {
    const context = get(contextProps, 'data.pageBy', null);
    const hbData = get(context, 'acf_content_builder.contentBuilder', null);
    const heroBanner = hbData ? refactorHb(hbData[0], 'shb') : null;

    const data = params.id === '404' ? {
      heroBanner
    } : {}

    return {
      revalidate: (process.env.NEXT_STATIC_EXPORT && process.env.NEXT_STATIC_EXPORT.toString() === 'true') ? false : 1,
      props: {
        ...data,
        type: params.id,

      }
    }
  } else { 
    return { revalidate: (process.env.NEXT_STATIC_EXPORT && process.env.NEXT_STATIC_EXPORT.toString() === 'true') ? false : 1, props: {} }
  }
}

export default StaticlyTemplates
